import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(3),
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
    border: `1px solid ${theme.palette.background.secondary.main}`,

    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
      borderRadius: theme.spacing(2)
    }
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    maxWidth: 800,
    padding: theme.spacing(6),

    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3),
      maxWidth: '100%'
    }
  },
  iconContainer: {
    marginBottom: theme.spacing(4),

    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(2)
    }
  },
  errorIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(2),

    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(1)
    }
  },
  errorCode: {
    fontSize: 120,
    fontWeight: 900,
    color: theme.palette.primary.main,
    lineHeight: 1,
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.1)',

    [theme.breakpoints.down('sm')]: {
      fontSize: 60
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 40
    }
  },
  cowIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 120,
    height: 120,
    backgroundColor: theme.palette.background.secondary.main,
    borderRadius: '50%',
    padding: theme.spacing(2),
    boxShadow: '0 4px 16px rgba(120, 74, 66, 0.2)',

    [theme.breakpoints.down('sm')]: {
      width: 60,
      height: 60,
      padding: theme.spacing(1)
    },
    [theme.breakpoints.down('xs')]: {
      width: 50,
      height: 50
    }
  },

  cowIcon: {
    width: '100%',
    height: '100%',

    '& path': {
      fill: theme.palette.primary.main
    }
  },

  title: {
    fontSize: theme.app.typography.title.fontSize,
    fontWeight: theme.app.typography.title.fontWeight,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(3),
    fontFamily: theme.app.typography.fontFamily.main,

    [theme.breakpoints.down('sm')]: {
      fontSize: 24,
      marginBottom: theme.spacing(2)
    }
  },
  description: {
    fontSize: 16,
    fontWeight: 400,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(5),
    maxWidth: 500,
    lineHeight: 1.6,
    fontFamily: theme.app.typography.fontFamily.secondary,

    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(3),
      maxWidth: '100%'
    }
  },

  actionsContainer: {
    display: 'flex',
    gap: theme.spacing(3),
    flexWrap: 'wrap',
    justifyContent: 'center',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: '100%',
      gap: theme.spacing(2)
    }
  },
  primaryButton: {
    padding: theme.spacing(1.5, 4),
    fontSize: theme.app.typography.paragraph.fontSize,
    fontWeight: 600,
    textTransform: 'none',
    borderRadius: theme.spacing(1),
    boxShadow: '0 2px 8px rgba(120, 74, 66, 0.3)',
    transition: 'all 0.3s ease',
    minWidth: 180,

    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(120, 74, 66, 0.4)'
    },

    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
      padding: theme.spacing(1.5, 2)
    }
  },
  secondaryButton: {
    padding: theme.spacing(1.5, 4),
    fontSize: theme.app.typography.paragraph.fontSize,
    fontWeight: 600,
    textTransform: 'none',
    borderRadius: theme.spacing(1),
    borderWidth: 2,
    minWidth: 180,
    transition: 'all 0.3s ease',

    '&:hover': {
      transform: 'translateY(-2px)',
      borderWidth: 2
    },

    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
      padding: theme.spacing(1.5, 2)
    }
  }
}))
